// pdf.js of the PDF block (@eeacms/volto-pdf-block), pinned in package.json.
// Its worker is served from public/static/pdfjs/ of this theme instead of a
// CDN and has to be of the same version, pdf.js refuses any other (#22801)
export const PDFJS_VERSION = '2.2.228';
export const PDF_WORKER_SRC = `/static/pdfjs/${PDFJS_VERSION}/pdf.worker.min.js`;

// Safari on iOS leaves a canvas of more than 16777216 pixels (4096 x 4096)
// blank, a plan in A0 needs 55 million on a phone. The PDF viewer draws such
// pages at a lower resolution, like maxCanvasPixels of the pdf.js viewer
// (#22801)
export const MAX_CANVAS_PIXELS = 16777216;
